<!-- CONTAINER -->
<div class="bg-white py-36px px-24px rounded-tl-[24px] rounded-tr-[24px]">
	<app-search-filter
		searchKey="BOOKING.BOOKING_LIST.SEARCH"
		(keyWord)="
			packageFilter.searchText = $event;
			packageFilter.paging.pageNumber = 1;
			getPackages()
		"
	></app-search-filter>

	<!-- table -->
	<app-packages-table
		(refreshData)="getPackages()"
		[packages]="packages"
		[packageFilter]="packageFilter"
		[totalCount]="totalCount"
		[queryParams]="queryParams"

	></app-packages-table>

	<!-- no data found -->
	<app-no-data-found
		*ngIf="!packages?.length"
		text="PACKAGES.NO_PACKAGES_YET"
		imageName="packages.svg"
		[buttonWidth]="200"
		buttonTitle="PACKAGES.ADD_PACAKEG"
		(clickEvent)="addPackage()"
	></app-no-data-found>
</div>

<!-- pagination -->
<div class="py-5 max-mobile:overflow-auto">
	<app-pagination
		[totalCount]="totalCount"
		[pageNumber]="packageFilter.paging.pageNumber"
		[pageCount]="packageFilter.paging.pageSize"
		(currentPage)="pageChanged($event, packageFilter.paging.pageSize)"
		(itemsCountPerPage)="pageChanged(1, $event)"
	></app-pagination>
</div>

<!-- fixed button -->
<app-fixed-button
	[buttonWidth]="200"
	buttonTitle="PACKAGES.ADD_PACAKEG"
	[imgPath]="'add-white.svg'"
	(clickEvent)="addPackage()"
>
</app-fixed-button>
